import { render, staticRenderFns } from "./SpeakingModel.vue?vue&type=template&id=67788785&scoped=true&"
import script from "./SpeakingModel.vue?vue&type=script&lang=js&"
export * from "./SpeakingModel.vue?vue&type=script&lang=js&"
import style0 from "./SpeakingModel.vue?vue&type=style&index=0&id=67788785&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67788785",
  null
  
)

export default component.exports